/*
* Adds a custom div into the menu item for personalization tokens to also display a styled description
*/
export const addCustomDescriptionsToPersonalizationTokens = (title: string, description: string, tokenCount: number) => {
    if (tokenCount > 0) {
        // grab the rendered div from the toolbar + dropdown insert menu where personalization tokens exist
        const menuItemDiv = document.querySelector(`div[title="${title}"][role="menuitem"]`) as HTMLDivElement;

        // sometimes the render is triggered mutliple times per menu item -- ensure that we're only adding the description once per node
        if (menuItemDiv.children.length === 1) {
            // create the description div
            let customDescriptionDiv = document.createElement('div');
            customDescriptionDiv.textContent = description;
            customDescriptionDiv.style.fontSize = "10px";
            customDescriptionDiv.style.color = "#7f7f7f";
            customDescriptionDiv.style.marginLeft = "4px";

            // append a copy of the div to both toolbar and dropdown menu items
            menuItemDiv.style.fontSize = "14px";
            menuItemDiv.style.color = "#333333";
            menuItemDiv.style.display = "flex";
            menuItemDiv.style.flexDirection = "column";
            menuItemDiv.style.alignItems = "flex-start";
            menuItemDiv.appendChild(customDescriptionDiv);
        }
    }
}